import { render, staticRenderFns } from "./changeFlag.vue?vue&type=template&id=b2cbcf86&"
import script from "./changeFlag.vue?vue&type=script&lang=js&"
export * from "./changeFlag.vue?vue&type=script&lang=js&"
import style0 from "./changeFlag.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports